import type { RequestConfig } from '@customTypes/index';
import type { ContractTermsDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type PostClubProfileContractTermsRequest = {
  clubId: string;
  data: ContractTermsDto;
};

export type PostClubProfileContractTermsParams =
  RequestConfig<PostClubProfileContractTermsRequest>;

export const postClubProfileContractTerms = async ({
  params,
  config
}: PostClubProfileContractTermsParams) =>
  api.post(
    `/api/ClubProfile/contract-terms/${params.clubId}`,
    params.data,
    config
  );
